import styled from 'styled-components';
import { lighten } from 'polished';

import 'antd/lib/spin/style/index.css';

export const BreadcumbsContainer = styled.div`
  margin: 0 auto 5px auto;
  width: auto;
  max-width: 1068px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  div.voltar {
    display: flex;
    align-items: center;
    flex-direction: row;
    margin-right: 20px;
    padding-top: 2px;
    button {
      display: flex;
      align-items: center;
      flex-direction: row;
      border: none;
      background: none;
      color: #619b30;
      font-weight: bold;
    }
  }
`;

export const PageTitle = styled.div`
  margin: 0 auto 30px auto;
  width: auto;
  max-width: 1068px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  div.ant-select .ant-select-arrow {
    font-size: 12px;
  }
  div.headerInline {
    display: flex;
    flex: 1;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    div.boxSearch {
      margin-left: 20px;
      form {
        display: flex;
        flex-direction: row;
        align-items: center;
      }
      label {
        width: 244.5px;
        height: 33.4px;
        padding: 0 10px;
        border-radius: 3px;
        box-shadow: inset 0px 1px 0px 0px #c7c7c794;
        border: solid 1px #c7c7c794;
        background: #ffffff;
        display: flex;
        flex-direction: row;
        align-items: center;
      }
      input {
        border: 0;
        color: #74a50a;
        margin: 0 0 0 5px;
        &::placeholder {
          color: #282828;
        }
      }
      button {
        margin-left: 4px;
        height: 33px;
        padding: 0 20px;
        border-radius: 3.5px;
        background-color: ${props => (props.clean ? '#235f6e' : '#74a50a')};
        border: none;
        color: #fff;
        display: flex;
        align-items: center;
      }
      button.limparBusca {
        /* width: 130px; */
        height: 34px;
        border-radius: 3.5px;
        background-color: #235f6e;
        border: none;
        color: #ffffff;
        margin-left: 20px;
      }
    }
  }
  p {
    margin-left: 10px;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.21;
    letter-spacing: 0.01px;
    color: #999999;
    span {
      text-transform: capitalize;
      font-size: 14px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.21;
      letter-spacing: 0.01px;
      color: #74a50a;
    }
  }
  span {
    font-size: 18px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.28;
    letter-spacing: 0.01px;
    text-align: left;
    color: #619b30;
  }
  div.voltar {
    display: flex;
    align-items: center;
    flex-direction: row;
    margin-right: 20px;
    padding-top: 2px;
    button {
      display: flex;
      align-items: center;
      flex-direction: row;
      border: none;
      background: none;
      color: #619b30;
      font-weight: bold;
    }
  }

  /* 
    SELECT STYLES
  */

  .ant-select-disabled .ant-select-selection {
    background-color: #f6f6f6;
    color: #282828;
  }

  .ant-select-selection--single {
    height: 34px;
  }

  .ant-select-selection {
    background-color: #fff;
    box-shadow: inset 0px 1px 0px 0px #c7c7c794;
    border: 1px solid #c7c7c794;
  }

  .ant-select-selection:hover {
    border-color: #74a50a;
  }
  .ant-select-focused .ant-select-selection,
  .ant-select-selection:focus,
  .ant-select-selection:active {
    border-color: #74a50a;
    border-right-width: 1px !important;
    outline: 0;
    -webkit-box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  }

  .ant-select-open .ant-select-selection {
    border-color: #74a50a;
  }

  .ant-select-dropdown.ant-select-dropdown--multiple
    .ant-select-dropdown-menu-item-selected
    .ant-select-selected-icon,
  .ant-select-dropdown.ant-select-dropdown--multiple
    .ant-select-dropdown-menu-item-selected:hover
    .ant-select-selected-icon {
    display: inline-block;
    color: #74a50a;
  }
`;

export const BoxContent = styled.div`
  width: 1068px;
  min-height: 200px;
  padding: 30px 10px;
  margin: 0 auto;
  border: solid 0.8px #ebebeb;
  background-color: #f9f9f9;

  input {
    &:disabled {
      background: #f1f1f1;
    }
  }

  div.boxSpin {
    display: flex;
    justify-content: center;
    padding: 50px;
  }

  .espaco-5 {
    margin: 5px;
  }

  .espaco-10 {
    margin: 10px;
  }

  .espaco-15 {
    margin: 15px;
  }

  .espaco-20 {
    margin: 20px;
  }

  .input-txt {
    width: 100%;
    background: #ffffff;
    border: 0;
    border-radius: 4px;
    height: 35px;
    padding: 0 15px;
    color: #282828;
    margin: 0 0 0 0;
    box-shadow: inset 0px 1px 0px 0px #c7c7c794;
    border: solid 1px #c7c7c794;
  }

  .campos-dados-do-contato-para-suporte {
    padding: 0 30px;
  }

  .coluna-botao {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-content: flex-end;
    align-items: flex-end;
    /* padding: 5px;
background-color: red;
  flex: 1; */
  }

  .botao-azul {
    margin-top: 10px;
    min-width: 120px;
    padding: 0 20px;
    height: 34px;
    line-height: 34px;
    border-radius: 3.5px;
    background-color: #235f6e;
    border: none;
    color: #ffffff;
    display: flex;
    flex: 1;
    flex-direction: row;
    justify-content: center;
    align-content: center;
    align-content: center;
    a {
      color: #fff;
    }

    svg {
      margin-top: 8px;
      margin-right: 8px;
    }
  }

  .exclusao {
    background-color: #cc0000 !important;
    min-width: 100px;
  }

  .titulo-secundario {
    color: #74a50a;
  }
`;

export const BoxContentHeader = styled.div`
  padding: 10px 20px;
  display: flex;
  align-self: center;
  height: 30px;
  div {
    display: flex;
    flex-direction: row;
    align-items: center;
    min-width: 120px;
    svg {
      color: #dddbdb;
    }
    span.extensaoHeader {
      width: 150px;
      text-align: left;
    }
    span.nomeHeader {
      width: 218px;
      padding-left: 22px;
    }
    span.categoriaHeader {
      width: 90px;
    }
    span.dataHeader {
      margin-left: 107px;
      padding-left: 32px;
    }

    span {
      display: flex;
      flex-direction: row;
      align-items: center;
      font-size: 13px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.23;
      letter-spacing: 0.01px;
      color: #727272;
    }
  }
`;

export const BoxList = styled.div`
  width: '100%';
  height: 70px;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  background-color: #ffffff;

  margin-top: 15px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  color: #235f6e;

  div.extensao {
    width: 95px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    padding-left: 20px;
    // border: 1px solid orange;
    font-size: 15px;
    font-weight: bold;
    line-height: 18px;
    letter-spacing: 0px;
    text-align: left;
    color: #235f6e;
  }

  div.nome {
    padding-left: 47px;
    margin-left: 35px;
    width: 230px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    // border: 1px solid red;
    align-items: center;
    font-size: 13px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.15;
    letter-spacing: 0.46px;
    color: #235f6e;

    div {
      display: flex;
      flex-direction: row;
      align-items: center;

      width: 100%;
      img {
        margin-left: -30px;
      }
    }
  }

  div.categoria {
    width: 230px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    // border: 1px solid red;
    align-items: center;
    font-size: 13px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.15;
    letter-spacing: 0.46px;
    color: #235f6e;

    div {
      display: flex;
      flex-direction: row;
      align-items: center;

      width: 100%;
      img {
        margin-left: -30px;
      }
    }
  }

  div.data {
    // border: 1px solid green;
    /* flex: 1; */
    display: flex;
    padding-left: 12px;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;

    font-size: 15px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.2;
    letter-spacing: 0.01px;
    text-align: center;
    color: #235f6e;
    width: 140px;
  }

  div.buttons {
    /* border: 1px solid blue; */
    /* width: 430px; */
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    // display: flex;
    // flex-direction: column;
    align-items: center;
    padding-right: 20px;
    button {
      color: #fff;
      border: none;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      height: 34px;
      border-radius: 3.5px;
      background-color: #235f6e;
      font-size: 13px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.15;
      letter-spacing: normal;
      text-align: center;
      color: #ffffff;

      svg,
      img {
        margin-right: 5px;
      }
    }
    button.edit-button {
      margin-left: 20px;
      width: 100px;
      background-color: #235f6e;
      margin-right: 20px;
      margin-bottom: 5px;
    }
    button.save-button {
      margin-left: 20px;
      width: 100px;
      background-color: #74a50a;
      margin-right: 20px;
    }
  }
`;

export const BoxPagination = styled.div`
  padding: 40px 30px 30px 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  ul {
    color: #235f6e;
    a {
      color: #235f6e;
      font-size: 13px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: 0.01px;

      svg {
        margin-bottom: -8px;
      }
    }

    a.arrowLeft {
      display: inline-block;
      margin-right: 70px;
    }
    a.arrowRight {
      display: inline-block;
      margin-left: 70px;
    }

    li.ant-pagination-item {
      border: none;
      background-color: transparent;
      width: 26px;
      min-width: 26px;
      height: 26px;
      line-height: 24px;
      a {
        font-size: 13px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: 0.01px;
        color: #235f6e;
      }
    }
    li.ant-pagination-item-active {
      background-color: #74a50a;
      border-radius: 0;
      a {
        color: #fff;
      }
    }
  }
`;

export const ModalContainer = styled.div`
  div.bodyChoose {
    width: 480px;
    margin-top: 5px;
    margin-left: -24px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 0 47px 0 45px;

    div.bodyChoosebox {
      width: 290px;
      padding: 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-direction: row;
      margin: 40px 0;
      button {
        width: 114px;
        height: 127px;
        border: none;
        background: #ffffff;
        box-shadow: 2px 1px 9px rgba(0, 0, 0, 0.12);
        border-radius: 3px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        > svg {
          color: #74a50a;
        }

        > span {
          font-style: normal;
          font-weight: bold;
          font-size: 12px;
          line-height: 14px;
          color: #5b5353;
          display: block;
          margin: 10px 0;
        }

        > p {
          font-size: 11px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.15;
          letter-spacing: 0.01px;
          text-align: center;
          color: #5b5353;
        }
        &:hover {
          background: #74a50a;
          > svg {
            color: #fff;
          }
          > span {
            color: #fff;
          }
          > p {
            color: #fff;
          }
        }
      }
    }
  }

  div.ModalBody {
    width: 480px;
    margin-top: 5px;
    margin-left: -24px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 47px 0 45px;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.43;
    letter-spacing: 0.01px;
    color: #cc0000;
    div.voltarEscolha {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      button {
        font-style: normal;
        font-weight: bold;
        font-size: 15px;
        line-height: 14px;
        border: none;
        color: #999;
        background-color: transparent;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: row;
        svg {
          margin-right: 7px;
        }
      }
    }
    p {
      font-size: 13px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.15;
      letter-spacing: 0.01px;
      text-align: center;
      color: #282828;
    }
  }

  div.fileInfoBox {
    width: 90%;
    padding: 30px 0;
  }

  form.formUpload {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    div.boxFileName {
      display: flex;
      flex-direction: column;
      width: 100%;
      > div {
        font-size: 14px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 2;
        letter-spacing: 0.01px;
        text-align: left;
        color: #74a50a;
      }
      > div + div {
        margin-top: 20px;
      }
    }
    span {
      align-self: flex-start;
    }
    input {
      margin-top: 3px;
      width: 100%;
      background: #ffffff;
      border: 0;
      border-radius: 4px;
      height: 35px;
      padding: 0 15px;
      color: #282828;
      box-shadow: inset 0px 1px 0px 0px #c7c7c794;
      border: solid 1px #c7c7c794;
    }
    button {
      margin-top: 27px;
      width: 153px;
      height: 34px;
      border-radius: 3.5px;
      background-color: #74a50a;
      border: none;
      color: #fff;
      align-self: center;
    }
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 10px 30px;

  h2 {
    font-size: 24px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.21;
    letter-spacing: 0.01px;
    text-align: center;
    color: #282828;
    span {
      color: #74a50a;
    }
  }
`;
